import React, { useEffect, useState } from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import Accordion from "react-bootstrap/Accordion";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { ReactComponent as UserIcon } from "../../../../assets/userIcon.svg";
import "./sidebar.css";

const SidebarMenu = ({ show, handleClose }) => {
  const [categoryArray, setCategoryArray] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/category/get`
        );
        if (res.data.statusCode === 1 && res.data.data.length) {
          setCategoryArray(res.data.data);
        }
      } catch (err) {
        console.error("Category fetch error:", err);
        setCategoryArray([]);
      }
    };
    fetchCategories();
  }, []);

  const handleNavigation = (path) => {
    navigate(path);
    handleClose();
  };

  return (
    <div className="category_main">
      <Offcanvas show={show} onHide={handleClose} className="w-75">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title className="fw-bold">Category</Offcanvas.Title>
        </Offcanvas.Header>
        <div className="border" />
        <Offcanvas.Body>
          <div className="d-flex flex-column justify-content-between h-100">
            <div>
              {categoryArray.map((item, index) => (
                <div
                  key={index}
                  className="category_title my-2 py-3"
                  onClick={() => handleNavigation(`/category/${item._id}`)}
                >
                  {item.name}
                </div>
              ))}
            </div>

            <div>
              <hr />
              <Accordion className="p-0 mt-3">
                <Accordion.Item eventKey="0">
                  <Accordion.Header
                    className="contact-us-btn"
                    onClick={() => handleNavigation("/contact-us")}
                  >
                    <span>Contact Us</span>
                  </Accordion.Header>
                </Accordion.Item>

                <Accordion.Item eventKey="1">
                  <Accordion.Header>Our Policy</Accordion.Header>
                  <Accordion.Body className="text-center">
                    {[
                      { label: "Refund Policy", path: "/refund-policy" },
                      { label: "Privacy Policy", path: "/privacypolicy" },
                      { label: "Shipping Policy", path: "/shippingpolicy" },
                      { label: "Terms of Service", path: "/termsofservice" },
                    ].map((link) => (
                      <div
                        key={link.path}
                        className="my-3 policy-link"
                        onClick={() => handleNavigation(link.path)}
                      >
                        {link.label}
                      </div>
                    ))}
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="2">
                  <Accordion.Header>QUICK LINKS</Accordion.Header>
                  <Accordion.Body className="text-center">
                    {[
                      { label: "About Us", path: "/about-us" },
                      { label: "Track Order", path: "/order-tracking" },
                      { label: "FAQ", path: "/faqs" },
                    ].map((link) => (
                      <div
                        key={link.path}
                        className="my-3 policy-link"
                        onClick={() => handleNavigation(link.path)}
                      >
                        {link.label}
                      </div>
                    ))}
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
              <hr />
              <div className="text-center user-login">
                <UserIcon />
                <span className="ms-2">Login</span>
              </div>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
};

export default SidebarMenu;
